// extracted by mini-css-extract-plugin
export default {"Navbar":"MainNavbar_Navbar__Go-0X","AdminLabel":"MainNavbar_AdminLabel__4dyoK"};